import { render } from "./SelectedCourse.component.vue?vue&type=template&id=6501eb96&scoped=true&ts=true"
import script from "./SelectedCourse.component.vue?vue&type=script&lang=ts"
export * from "./SelectedCourse.component.vue?vue&type=script&lang=ts"

import "./SelectedCourse.component.vue?vue&type=style&index=0&id=6501eb96&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6501eb96"]])

export default __exports__